// Products that require impersonation, and will have unexpected results
// if accessed by an `partner` session
const PRODUCTS_WITH_LEGACY_SSO = [
  'MP-B77R7GG4QHGKF5RMVSLVZPD3D5JSTZ4K',
  'MP-QCF8BN6ZLCF8VG44ZBFKK4WC8ZLHMPGB',
  'MP-MLR5D46VS7LD435B3GJCQTBD5DKRXC6H',
  'MP-MLXNLFH72ZZKHTLDKQ784PCZPJPTPV63',
  'MP-GB6TPVDDJVK3CK7MQW86XG75TMRCXNJK',
  'MP-DWZ34CZNP45MK4N4X4GH76QQF448P3TD',
  'MP-SS2FMDDSML3TG3BGFVDVT8ZTF7TDZ8SF',
  'MP-2da7414a9f604f518d6ae0127080f9e2',
  'MP-11b0a570be284547a9ea1ad6fc26a261',
  'MP-LHNDH2N6X5H6JHMWRQ4P7D6WNWRRSCH5',
  'MP-8RQ7CTD5LBDFF2V2HQG3JF26N48PSNGR',
  'MP-7KCQR6C2M2LBSXQXLPM3GG3FHQLXSBMF',
  'MP-W74STW72G4WVKL52LT45NFJC3XH7M5J2',
  'MP-aa5151cf1bb840819dbdf85a55e717bf',
  'MP-CM77Q8QDQVD2FL5X6J5CG5M4QQBC6ZTB',
  'MP-3QXRWPFX4BTVGZ3NBPSWPS8L3S7QS66W',
  'MP-5H2HL8GGBZKMX8XNHSKT5SRH8Q2L3ZCN',
  'MP-FVGG6TS6J5V5ZJQPS7GGP25838QSXCVD',
  'MP-f72c489e967649b082a84f42760eaa1b',
  'MP-SGBV7TJ5TZN557NFCGPXBSTHC5STM784',
  'MP-L3R7WQ5QGQ8H5WWFX6NXSSNXJMKNPLDG',
  'MP-F6BPK4L5B5CLCXHWLF84MJQHQX63W8X5',
  'MP-8B4M6FR6MZLQSRNW37CHQ4QSFX2PG5XR',
  'MP-JSLWMC6KWSVCBFNC5J846W5CK4K4FRWP',
  'MP-7P6HQ6FV3W767MH8BHXN2TT458QNM4WZ',
  'MP-RC8VV8K5DV368F6WJ3ZCSKWG2Q62QSDC',
  'MP-LMMGS3SJ4H6RHS6RVZTCJP43KZRLQWQR',
  'MP-JFW4X5KMBK44GT4SBDZL72KVP2DPZQZS',
  'MP-G222MCLJMR86JCFZWDDVZDXZ7NXZWNKR',
  'MP-HPSWQNKQRPF6STQDV6FMFPXHHXJ58XLN',
  'MP-647TKQGPVKXF5CHQCPZ4RK78CFTWHWFH',
  'MP-852C4QSSTZH3Z3BF4NFVKDN2KVCP278D',
  'MP-03fc7fb5e3b848cd88523515cd66ea9c',
  'MP-492e1467b897434aa528bd8e74dcde0d',
  'MP-XBRSXQSPSC4H4TSGMMMKHR3GQZMHL2LH',
  'MP-NFWJLTZ2CN55VMRNMHQ46PNSG66M287J',
  'MP-T8ZDKPPX5RH2QZS6J6TRVWQ7FNW8G24D',
  'MP-HZBQQCFV6WMVFB2JNMFFWN5658L23LRP',
  'MP-NT6JS5PC4S2RNLQXNDVJDCD55TBMQHDQ',
  'MP-VCMRKHPF7QQJGDR6PHN56VSXHDNKK52R',
  'MP-6TZ5WKDL8ZR5GBHX7QPQ7DTRSQDQBCN7',
  'MP-VN8Z4RDGHJBJM5VCFQS5TZXPC4B5MBD5',
];
export function productCanSso(productId: string): boolean {
  // products are considered sso-able if they are not in the list of legacy sso products
  return !PRODUCTS_WITH_LEGACY_SSO.includes(productId);
}
